import React from 'react';

export default function NonCensito() {
  const params = new URLSearchParams(window.location.search);
  const email  = params.get('email') || '';

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-mark bop-non-censito__logo-mark--danger">!</div>
        </div>

        <h1 className="login-title">Accesso negato</h1>

        <p className="login-subtitle">
          Il tuo account Google non è autorizzato ad accedere al sistema.
          Contatta l'amministratore per farti codificare.
        </p>

        {email && (
          <div className="bop-non-censito__email-box">
            {email}
          </div>
        )}

        <a href="/" className="login-google-btn bop-non-censito__back-link">
          ← Torna al login
        </a>
      </div>
    </div>
  );
}
